import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import { StoreModule } from '@ngrx/store';
import { TranslateModule } from '@ngx-translate/core';
import { TreeViewModule } from '@progress/kendo-angular-treeview';
import { I18nModule } from 'app/core/services/i18n/i18n.module';
import { SelectMerkmalDialogComponent } from './select-merkmal-dialog.component';
import { IsLoadingModule } from 'app/shared/directives/is-loading-directive';
import { FocusNearestModule } from 'app/shared/directives/focusNearest/focusNearest.module';

@NgModule({
    imports: [
        CommonModule,
        FormsModule,
        RouterModule,
        TreeViewModule,
        ReactiveFormsModule,
        TranslateModule,
        I18nModule,
        StoreModule,
        IsLoadingModule,
        FocusNearestModule
    ],
    declarations: [SelectMerkmalDialogComponent],
    exports: [SelectMerkmalDialogComponent]
})
export class SelectMerkmalDialogModule {}
